
import { useEffect } from 'react'
import Select from 'react-select'
import { ProjectNameDDLAPI, ProjectTypeNameDDLAPI, ReportProjectNameDDLAPI, ReportProjectTypeDDLAPI, SectorDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const ReportProjectNameDataDDL = (props) => {
    const { ReportProjectName, setReportProjectName, ReportProjectType, WardName, PopUpField, rowData, Flag, isCompulsory } = props

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            UserID,
            token,
            M_ProjectTypeID: ReportProjectType.ID
        }
        dispatch(ReportProjectNameDDLAPI({ data }))
    }, [ReportProjectType.ID])

    const { ReportProjectNameData } = useSelector(state => state.ReportProjectNameDDLData)

    useEffect(() => {
        handleProjectDDL()
    }, [ReportProjectNameData])

    const handleProjectDDL = () => {
        // console.log(DeptDDLDataa)
        if (ReportProjectNameData && ReportProjectNameData.table && ReportProjectNameData.table.length > 0) {
            let list = ReportProjectNameData.table.map((item, index) => ({
                value: item.projectID,
                label: item.projectName,
            }))

            setReportProjectName({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_ProjectTypeID : 0,
                Label: Flag === 'Update' ? rowData.projectType : "Select...",
            })
        }
        else {
            setReportProjectName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Project Name {(Flag || isCompulsory) && <AstricSign />} </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: ReportProjectName.ID, label: ReportProjectName.Label }}
                onChange={(e) => {
                    e ?
                        setReportProjectName({ ...ReportProjectName, ID: e.value, Label: e.label })
                        :
                        setReportProjectName({ ...ReportProjectName, ID: 0, Label: "Select..." })

                }}
                options={ReportProjectName.DDL}
            />
        </div>
    )
}